import { faTimes } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import Trade from '../../Messages/Trade'
import Progressbar from '../ProgressBar'

const COUNTER_DEFAULT = 300

const TradeAlert = ({ message, toggleAlert }) => {
  const [counter, setCounter] = useState(COUNTER_DEFAULT)
  const [counterID, setCounterID] = useState(COUNTER_DEFAULT)

  useEffect(() => {
    clearTimeout(counterID)
    setCounter(COUNTER_DEFAULT)
    setCounterID(COUNTER_DEFAULT)
  }, [message])

  useEffect(() => {
    if (counter > 0) {
      const id = setTimeout(() => setCounter(counter - 1), 1000)
      setCounterID(id)
    } else {
      clearTimeout(counterID)
      toggleAlert(false)
    }
  }, [counter])

  return (
    <div className="hidden md:flex flex-col gap-1 lg:max-w-96 bg-neutral-200 dark:bg-neutral-800 py-2 rounded-xl">
      <div className="relative flex justify-between items-center gap-2">
        <Progressbar progress={(counter / COUNTER_DEFAULT) * 100} />
        <button
          onClick={() => toggleAlert(false)}
          className="button-x z-10 absolute right-2 -top-2"
        >
          <FontAwesomeIcon icon={faTimes} className="!w-4 !h-4" />
        </button>
      </div>
      <Trade message={message} truncate={true} />
    </div>
  )
}

TradeAlert.propTypes = {
  message: PropTypes.object.isRequired,
  toggleAlert: PropTypes.func.isRequired
}

export default TradeAlert
